import { createSlice } from '@reduxjs/toolkit';

// One-time forced cutover: old bearer and refresh tokens must not survive in
// script-readable storage after the secure-cookie migration.
if (typeof window !== 'undefined') {
  window.localStorage.removeItem('token');
  window.localStorage.removeItem('refreshToken');
  window.localStorage.removeItem('role');
}

const initialState = {
  token: null,
  user: null,
  role: null,
  isAuthenticated: false,
  sessionChecked: false,
  loading: true,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      const { token, user, role } = action.payload;

      if (token !== undefined) state.token = token;
      if (user !== undefined) state.user = user;
      if (role !== undefined) state.role = role;

      state.isAuthenticated = Boolean(state.token);
      state.sessionChecked = true;
      state.loading = false;
      state.error = null;
    },
    sessionCheckComplete: (state) => {
      state.sessionChecked = true;
      state.loading = false;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
      state.sessionChecked = true;
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.role = null;
      state.isAuthenticated = false;
      state.sessionChecked = true;
      state.error = null;
      state.loading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      if (action.payload?.role) state.role = action.payload.role;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  sessionCheckComplete,
  loginFailure,
  logout,
  clearError,
  updateUser,
} = authSlice.actions;

export default authSlice.reducer;
